import { Button, Typography } from "@mui/material";
import { useLocalization } from "../hooks/useLocalization";
import ErrorIcon from "../icons/ErrorIcon";
import InfoPage from "./infoPage/InfoPage";

interface Props {
  title?: string;
  subtitle?: string;
  buttonText?: string;
}

const Error = ({ title, subtitle, buttonText }: Props) => {
  const { pages } = useLocalization();

  return (
    <InfoPage
      Icon={<ErrorIcon />}
      title={title || pages.error.title}
      subtitle={<Typography color="text.secondary">{subtitle || pages.error.subtitle}</Typography>}
    >
      <Button sx={{ width: "10rem" }} href="/" color="primary" variant="outlined">
        {buttonText || pages.error.button}
      </Button>
    </InfoPage>
  );
};

export default Error;
